import { isSupportedOperationTransport, OPERATION_TRANSPORT_PROTOCOL_VERSION } from "@mdbase-dev/connect-protocol";
import { parseStored } from "./runtime-utils.js";
export function pendingRecoveryTransports(storage, storagePrefix, operations, collectionId) {
    const prefix = `${storagePrefix}:pending-mutation:`;
    const versions = new Set();
    for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (!key?.startsWith(prefix))
            continue;
        const pending = parseStored(storage.getItem(key));
        if (!pending
            || !operations.includes(pending.operation)
            || (collectionId && pending.collectionId !== collectionId))
            continue;
        const version = pending.envelope?.protocol_version ?? pending.request?.protocol_version;
        if (version !== undefined
            && version !== OPERATION_TRANSPORT_PROTOCOL_VERSION
            && isSupportedOperationTransport(version)) {
            versions.add(version);
        }
    }
    return [...versions].sort((left, right) => right - left);
}
export function pendingMutationsUseKey(storage, baseKey, keyHandle) {
    return pendingMutationKeyHandles(storage, baseKey).has(keyHandle);
}
export function pendingMutationKeyHandles(storage, baseKey) {
    const handles = new Set();
    for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (key !== baseKey && !key?.startsWith(`${baseKey}:`))
            continue;
        const pending = parseStored(storage.getItem(key));
        if (pending?.keyHandle)
            handles.add(pending.keyHandle);
    }
    return handles;
}
export function removePendingMutations(storage, baseKey, removeKey) {
    const keys = [baseKey];
    for (let index = 0; index < storage.length; index += 1) {
        const key = storage.key(index);
        if (key?.startsWith(`${baseKey}:`))
            keys.push(key);
    }
    for (const key of keys) {
        const pending = parseStored(storage.getItem(key));
        if (pending?.keyHandle)
            removeKey(pending.keyHandle);
        storage.removeItem(key);
    }
}
